import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Table, Thead, Tbody, Tr, Th, Td, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, IconButton, Link, Select, Flex, Button } from '@chakra-ui/react';
import { FaPlay, FaFileAlt, FaPrint, FaSync } from 'react-icons/fa';
import YouTube from 'react-youtube';
import { BASE_URL } from '../../Globalapi/Globalapi';

const Staff_Material = () => {
  const [materials, setMaterials] = useState([]);
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [videoId, setVideoId] = useState('');
  const [materialUrl, setMaterialUrl] = useState('');
  const [isYouTube, setIsYouTube] = useState(false);
  const [error, setError] = useState('');
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');

  const jwt = sessionStorage.getItem('jwt');
  const userId = sessionStorage.getItem('user_id');
  const userType = sessionStorage.getItem('user_type');

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const classResponse = await axios.get(`${BASE_URL}/admin/class/class_master.php`);
        const subjectResponse = await axios.post(`${BASE_URL}/admin/subject/list_all_subject_to_teacher.php`, {
          pass: userId,
        })

        setClasses(classResponse.data.data || []);
        setSubjects(subjectResponse.data.data || []);
      } catch (error) {
        setError('Error fetching class or subject data');
        console.error(error);
      }
    };

    fetchFilters();
  }, []);

  useEffect(() => {
    if (jwt && userId && userType) {
      axios
        .post(
          `${BASE_URL}/staff/course_materials/list_teachers_uploaded_material.php`,
          { pass: userId },
          { headers: { Authorization: `Bearer ${jwt}` } }
        )
        .then((response) => {
          if (response.data.success) {
            setMaterials(response.data.materials || []);
            setFilteredMaterials(response.data.materials || []);
          } else {
            setError(response.data.message || 'Error from API');
            console.error('Error from API:', response.data.message);
          }
        })
        .catch((error) => {
          setError('Error fetching course materials');
          console.error('Error fetching course materials:', error);
        });
    } else {
      setError('No JWT, User ID, or User Type found');
    }
  }, [jwt, userId, userType]);

  const extractYouTubeID = (url) => {
    const standardMatch = url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^\s&]+)/);
    if (standardMatch) return standardMatch[1];

    const shortenedMatch = url.match(/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^\s&]+)/);
    if (shortenedMatch) return shortenedMatch[1];

    return null;
  };

  const handleVideoClick = (url) => {
    const videoID = extractYouTubeID(url);
    if (videoID) {
      setVideoId(videoID);
      setMaterialUrl(url);
      setIsYouTube(true);
      setIsOpen(true);
    } else {
      setVideoId('');
      setMaterialUrl(url);
      setIsYouTube(false);
      setIsOpen(true);
    }
  };

  const closeModal = () => {
    setIsOpen(false);
    setVideoId('');
    setMaterialUrl('');
    setIsYouTube(false);
  };

  const opts = {
    height: '600',
    width: '100%',
  };

  useEffect(() => {
    setFilteredMaterials(
      materials.filter(material => {
        const matchesClass = selectedClass ? material.class === selectedClass : true;
        const matchesSubject = selectedSubject ? material.subject === selectedSubject : true;
        return matchesClass && matchesSubject;
      })
    );
  }, [selectedClass, selectedSubject, materials]);

  return (
    <Box>
      <div style={{ backgroundColor: '#FBFBFD', height: '100vh' }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Course Material</h1>
            {/* <div className="action-buttons">
              <Button className="refresh-button" boxShadow="md" display={{ base: 'none', md: 'flex' }}
                backgroundColor='white' fontSize='11px' onClick={() => { console.log('Refresh button clicked'); }}>
                <FaSync color='#515B73' />
              </Button>
              <Button className="export-button" display={{ base: 'none', md: 'flex' }}
                backgroundColor='white' fontSize='11px' boxShadow="md">
                <FaPrint color='#515B73' />
                Print PDF
              </Button>
            </div> */}
          </div>
          <div className="breadcrumb">
            <span>Staff</span> / <span>Course Material</span> / <span>View</span>
          </div>
        </div>
        <Box p={6}>
          {error ? (
            <Text color="red.500" textAlign="center" mb={4}>{error}</Text>
          ) : (
            <Box>
              <Flex mb={4}>
                <Select placeholder="Select Class" onChange={(e) => setSelectedClass(e.target.value)} mr={2}>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.class}>{cls.class}</option>
                  ))}
                </Select>
                <Select placeholder="Select Subject" onChange={(e) => setSelectedSubject(e.target.value)}>
                  {subjects.map((sub) => (
                    <option key={sub.id} value={sub.subject}>{sub.subject}</option>
                  ))}
                </Select>
              </Flex>

              <div style={{ overflowX: 'auto' }}>

                <Table mt={4}  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
                  <Thead>
                    <Tr>
                      <Th>File Name</Th>
                      <Th>Class</Th>
                      <Th>Subject</Th>
                      <Th>Caption</Th>
                      <Th>Staff</Th>
                      <Th>Material File</Th>
                      <Th>Material Link</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {filteredMaterials.length > 0 ? (
                      filteredMaterials.map((material) => (
                        <Tr key={material.id}>
                          <Td>{material.file_name}</Td>
                          <Td>{material.class || 'N/A'}</Td>
                          <Td>{material.subject || 'N/A'}</Td>
                          <Td>{material.caption || 'N/A'}</Td>
                          <Td>{material.name || 'N/A'}</Td>
                          <Td>
                            {material.file_url ? (
                              <Link
                                href={material.file_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                display="flex"
                                alignItems="center"
                              >
                                <FaFileAlt style={{ marginRight: '8px' }} /> View File
                              </Link>
                            ) : (
                              'No File'
                            )}
                          </Td>
                          <Td>
                            {material.material_link ? (
                              <IconButton
                                icon={<FaPlay />}
                                aria-label="Play Material"
                                onClick={() => handleVideoClick(material.material_link)}
                                colorScheme="blue"
                              />
                            ) : (
                              'No Link'
                            )}
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan="7">
                          <Text textAlign="center">No materials available</Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </div>
            </Box>
          )}
        </Box>
      </div>

      {/* Modal for video */}
      <Modal isOpen={isOpen} onClose={closeModal} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Material</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {isYouTube ? (
              <YouTube videoId={videoId} opts={opts} />
            ) : (
              <Text>
                The content cannot be displayed in an iframe.{' '}
                <a href={materialUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>
                  Click here to view it directly
                </a>
              </Text>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Staff_Material;
